// extracted by mini-css-extract-plugin
export const favoriteButton = "favorite-button-module--favorite-button--3oIIh";